module.exports = __webpack_public_path__ + "static/map-0da1ba3b4d32846c54dcbb0fd917d29b.png";